import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchKnowledgeBases,
  createKnowledgeBase,
  updateKnowledgeBase,
  deleteKnowledgeBase,
} from "./knowledge-baseAPI";

export const getKnowledgeBases = createAsyncThunk(
  "knowledgeBase/getAll",
  async (accountId, { rejectWithValue }) => {
    try {
      return await fetchKnowledgeBases(accountId);
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch knowledge bases",
      );
    }
  },
);

export const saveKnowledgeBase = createAsyncThunk(
  "knowledgeBase/save",
  async ({ uuid, knowledgeBase }, { rejectWithValue }) => {
    try {
      if (uuid) {
        return await updateKnowledgeBase(uuid, knowledgeBase);
      } else {
        return await createKnowledgeBase(knowledgeBase);
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to save knowledge base",
      );
    }
  },
);

export const removeKnowledgeBase = createAsyncThunk(
  "knowledgeBase/remove",
  async (uuid, { rejectWithValue }) => {
    try {
      await deleteKnowledgeBase(uuid);
      return uuid;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

const knowledgeBaseSlice = createSlice({
  name: "knowledgeBase",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getKnowledgeBases.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getKnowledgeBases.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(getKnowledgeBases.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(saveKnowledgeBase.fulfilled, (state, action) => {
        const index = state.items.findIndex(
          (kb) => kb.uuid === action.payload.uuid,
        );
        if (index >= 0) {
          state.items[index] = action.payload;
        } else {
          state.items.push(action.payload);
        }
      })

      .addCase(removeKnowledgeBase.fulfilled, (state, action) => {
        state.items = state.items.filter((kb) => kb.uuid !== action.payload);
      });
  },
});

export default knowledgeBaseSlice.reducer;
